import React from 'react';
import { GpacLogo } from 'UI/res';

import { BorderLinearProgress, FullPageContainer, LoaderContainer } from './FullPageLoader.styled';

export const FullPageLoader = () => {
  return (
    <FullPageContainer>
      <LoaderContainer>
        <GpacLogo width="100%" />
        <BorderLinearProgress />
      </LoaderContainer>
    </FullPageContainer>
  );
};
